import { ref, computed } from 'vue'
import { api } from '../services/api.js'

const state = ref({
  raises: [],
  loading: false,
  error: null,
  lastUpdated: null,
  selectedDevelopment: '',
  developments: []
})

let refreshInterval = null

export function useCapitalRaises() {
  const fetchData = async (development = null) => {
    state.value.loading = true
    state.value.error = null
    
    try {
      const params = development ? { development } : {}
      const response = await api.get('/capital-raises/', { params })
      const data = response.data
      state.value.raises = data.raises || []
      state.value.lastUpdated = data.last_updated
      
      // Extract unique developments from raises
      const devSet = new Set(data.raises?.map(r => r.development) || [])
      state.value.developments = Array.from(devSet).sort()
      
    } catch (err) {
      state.value.error = err.message
      console.error('Error fetching capital raises:', err)
    } finally {
      state.value.loading = false
    }
  }

  const setDevelopment = (development) => {
    state.value.selectedDevelopment = development
    fetchData(development)
  }

  const startAutoRefresh = () => {
    // Refresh every 5 minutes
    refreshInterval = setInterval(() => {
      fetchData(state.value.selectedDevelopment || null)
    }, 5 * 60 * 1000)
  }

  const stopAutoRefresh = () => {
    if (refreshInterval) {
      clearInterval(refreshInterval)
      refreshInterval = null
    }
  }

  // Initial fetch
  fetchData()

  // Start auto-refresh
  startAutoRefresh()

  // Cleanup on unmount (handled by the component)
  return {
    // State
    raises: computed(() => state.value.raises),
    loading: computed(() => state.value.loading),
    error: computed(() => state.value.error),
    lastUpdated: computed(() => state.value.lastUpdated),
    selectedDevelopment: computed({
      get: () => state.value.selectedDevelopment,
      set: setDevelopment
    }),
    developments: computed(() => state.value.developments),
    
    // Actions
    fetchData,
    setDevelopment,
    startAutoRefresh,
    stopAutoRefresh
  }
}
